module.exports = __webpack_public_path__ + "img/rating.2efb08ad.svg";